import { useEffect } from "react";
import { shopifySetupStatus, signupSource } from "_constants";

const buildSignupParamsFromQuery = (query) => {
    const params = new URLSearchParams(query);
    params.set("signup_origin", signupSource.SHOPIFY);

    const name = query.get("name");
    if (name) {
        params.set("company", name);
    }

    for (const [key, value] of params.entries()) {
        if (value == null || value === "") {
            params.delete(key);
        }
    }

    return params;
};

export default function ShopifyCallback() {
    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const status = query.get("setupStatus");
        const user = JSON.parse(localStorage.getItem("user"));

        if (status === shopifySetupStatus.SHOP_CONNECTED) {
            window.location.href = "/company/channels";
            return;
        }

        const isReconnect = status === shopifySetupStatus.APP_UNINSTALLED;
        const isCreateAccount = !user && !isReconnect;

        const path = isCreateAccount
            ? "/signup/create-account"
            : "/shopify/connect-account";

        const params = isCreateAccount
            ? buildSignupParamsFromQuery(query)
            : query;

        window.location.href = `${path}?${params.toString()}`;
    }, []);

    return null;
}
